import React, { useEffect, useMemo, useRef, useState } from 'react';

import PropTypes from 'prop-types';

// @mui
import { Typography, Box, Divider, Button, Snackbar, MenuItem, Select, FormControl, InputLabel, Stack } from '@mui/material';

import { useTheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import RefreshIcon from '@mui/icons-material/Refresh';

import MuiAlert from '@mui/material/Alert';

import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';

// components
TrackInfo.propTypes = {
  lyrics: PropTypes.object,
  queue: PropTypes.object,
  queues: PropTypes.array,
  duration: PropTypes.number,
  start: PropTypes.number,
  track: PropTypes.object,
  setnewTrackCountdown: PropTypes.func
}


export default function TrackInfo (props) {
    const { track, queue, queues, start, duration, lyrics, setnewTrackCountdown} = props
    const [marginX, setMarginX] = useState(0);
    const [lyricsLine, setLyricsLine] = useState("");
    const lyricsRef = useRef()
    const lyricsInstance = useRef()

    const [pin, setPin] = useState(0);
    const interval = useRef()

    const [open, setOpen] = React.useState(false);
    const [nextQueue, setNextQueue] = useState('');


  const theme = useTheme();


    const handleClose = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }

      setOpen(false);
    };

    useEffect(() => {

      if (!pin) {
        setPin(start)
        if (interval.current) {
          clearInterval(interval.current)
        }
      } else {
        interval.current = setInterval(() => {
          setPin(p => p + 500)

        }, 500);
      }

      return () => {
        if (interval.current) {
          clearInterval(interval.current)
        }
      };
    }, [pin, start]);

    useEffect(() => {
      setPin(start)
    }, [start]);

    useEffect(() => {

        setMarginX(100 * pin / duration)
        if (pin > duration) setPin(0)

    }, [duration, pin]);

    function findclosestPin (lines, pin) {
      return lines.sort( (a, b) => Math.abs(pin - a.startTimeMs) - Math.abs(pin - b.startTimeMs) )[0];
    }

    useEffect(() => {
      // if (!pin || !lyrics || lyrics.syncType !== 'LINE_SYNCED')
      if (pin && !lyrics.error && lyrics.syncType === 'LINE_SYNCED' && lyrics.lines ) {
        const line = findclosestPin(lyrics.lines, pin)
        // console.log('newTime', newTime);
        if (line) {
          // const index = lyrics.lines.map(object => object.startTimeMs).indexOf(newTime.startTimeMs);
          setTimeout(() => {
            setLyricsLine(line.words)
          }, Math.max(0, line.startTimeMs - pin - 25));

        } else {
          setLyricsLine("")
        }
      } else {
        setLyricsLine("")
      }
      // return undefined
    }, [lyrics, pin]);

    // useEffect(() => {
    //   console.log('lyricsLine',lyricsLine);
    // }, [lyricsLine]);



  useEffect(() => {
    if (!lyricsInstance.current) return
    lyricsInstance.current.value = lyricsLine
  }, [lyricsLine]);



    const progressbar = useMemo (() => (
      <Divider sx={{ mt:1, mb:1, width: `${marginX}%`, height: 4, bgcolor: 'green'}} />
      // <Box sx={{ position:'absolute', marginX: `${marginX}%`, width: '100%', height: 4, bgcolor: 'green' }} />
    ), [marginX])

    const queuecard = (props) => {

      if (queue && queue.name) return (<Card sx={{ ...props, flexDirection:'row' }} >
      <CardContent sx={{ flex: '0 0 auto', flexGrow: 2}} >
        <Typography component="div" variant="caption">
          NEXT UP {'>>>'}
        </Typography>
        <Typography component="div" variant="h6">
        {queue.name}
        </Typography>
        <Typography variant="subtitle2" color="text.secondary" component="div">
          {queue.artists[0].name}
        </Typography>   
          {queuesList}
        
        </CardContent>


        <CardMedia 
          component="img"
          sx={{ width: { xs: '4vw', sm: '4vw', md: '10vw'}, flexGrow: 1, cursor: queue.preview_url ? 'pointer' : 'not-allowed' }}
          image={queue.album.images[0].url}
          alt={queue.name}
          onClick = {
            () => {
              if (queue.preview_url) {                        
                audio.current = new Audio(queue.preview_url)
                if (audio.current && audio.current.paused) {
                  audio.current.play()
                } else {
                  audio.current.pause()
                }
              } else {
                setOpen(true)
              }
            }
          }
          onMouseOut = {
            () => {
              if (audio.current && !audio.current.paused) audio.current.pause()
            }
          }
        />
      </Card>)
      return <></>

    }

    const queuesList = useMemo(() => {
      if (queues.length) return (
        <Stack direction={'row'}>
        <IconButton aria-label="refresh" onClick={() => setnewTrackCountdown(1)}>
            <RefreshIcon />
          </IconButton>
          <FormControl variant="standard" sx={{ m: 1}}>
          <InputLabel id="demo-simple-select-standard-label">{'...'}</InputLabel>
          <Select
            labelId="demo-simple-select-standard-label"
            id="demo-simple-select-standard"
            value={nextQueue}
            onChange={(e) => {}}
            label="เลือกเพลง"
          >
          {queues.map(queue => (<MenuItem key={queue.id} value={queue.id}>
            {queue.name}
          </MenuItem>))}
        </Select>
      </FormControl>
          </Stack> )
      return <></>
    }, [nextQueue, queues, setnewTrackCountdown])

    const audio = useRef()

    return (<><Card sx={{ display: 'flex', flexDirection:{ sm: 'row', md: 'column-reverse', lg: 'column-reverse'},  mt:1, flexGrow: 2}}>

    <Box flexGrow={1} />
    {/* {marginX} */}
    <CardContent sx={{ flex: '0 0 auto', flexGrow: 2}} >
      <Typography component="div" variant="h4">
      {track.name}
      </Typography>
      <Typography variant="subtitle1" color="text.secondary" component="div">
        {track.artists[0].name}
      </Typography>   
      {progressbar}
      {lyricsLine && <Typography variant="h3" component="div" color='pink'>
        {lyricsLine}
      </Typography>}

      <div ref={lyricsRef} className="totalTickInfo" id="dots-size" >
        <div data-repeat="true" aria-hidden="true">
          <span data-view="flip" />
        </div>
      </div>
    </CardContent>    
  <CardMedia
    component="img"
    sx={{ width: '10vw', flexGrow: 1, cursor: track.preview_url ? 'pointer' : 'not-allowed' }}
    image={track.album.images[0].url}
    alt={track.name}
    onClick = {
      () => {
        if (track.preview_url) {
          audio.current = new Audio(track.preview_url)        
          if (audio.current && audio.current.paused) {          
            audio.current.play()
          } else {
            audio.current.pause()
          }
        } else {
          setOpen(true)
        }
      }
    }
    onMouseOut = {
      () => {
        if (audio.current && !audio.current.paused) audio.current.pause()
      }
    }
  />
        {/* {progressbar} */}
        <div style={{ position: 'absolute', m: 1, right: 0, top: 0  }}>
            {queuecard({display: {xs: 'none', sm: 'none', md: 'flex'}})}
          </div>

    </Card>
    <div>{queuecard({display: {xs: 'flex', sm: 'flex', md: 'none'}})}</div>
    <Snackbar
        open={open}        
        autoHideDuration={1000}
        onClose={handleClose}
        message="เพลงนี้ไม่มี Preview"
      />
    </>)
}